// @ts-nocheck
import { Plugin } from '/home/runner/_work/VBIM-Vtwinning/VBIM-Vtwinning/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
